import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Box, Chip } from '@mui/material';
import ReportSelect from './ReportSelect';
import CancelIcon from '@mui/icons-material/Cancel';
import { useAtomValue } from 'jotai';
import { userBranchesAtom } from '../../Atoms';
import capitalize from '../../Helpers/StringsFormatting/capitalize';

const BranchesReportSelect = function BranchesReportSelect({
  classes,
  value = [],
  onChange,
  allDefault = false,
}) {
  const intl = useIntl();
  const userBranches = useAtomValue(userBranchesAtom);
  const [branches, setBranches] = useState(value);

  const handleChangeBranches = (e) => {
    setBranches(e.target.value);
  };

  const handleRemoveBranch = (e, value) => {
    e.preventDefault();
    const copyBranches = [...branches]; //copy of branches
    const index = copyBranches.indexOf(value);
    if (index !== -1) {
      //remove element of the provided index searched by value
      copyBranches.splice(index, 1);
      setBranches(copyBranches);
    }
  };

  useEffect(() => {
    onChange(branches);
  }, [branches]);

  useEffect(() => {
    if (allDefault && userBranches) {
      const allBranchDescriptions = userBranches?.map(({ id }) => id) || [];
      setBranches(allBranchDescriptions);
    }
  }, [allDefault, userBranches]);

  return (
    <ReportSelect
      value={branches}
      onChange={handleChangeBranches}
      classes={classes}
      fullWidth
      multiple
      size="large"
      padding="30px"
      label={intl.messages.BRANCH}
      items={userBranches?.map(({ id, branchDescription }) => {
        return {
          label: capitalize(branchDescription),
          value: id,
          active: true,
        };
      })}
      renderValue={(selected) => (
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 0.5,
            maxHeight: '100px',
            overflowY: 'auto',
          }}
        >
          {selected.map((value) => (
            <Chip
              clickable
              key={`value-${value}`}
              label={capitalize(
                userBranches?.find((b) => b.id === value)?.branchDescription
              )}
              deleteIcon={
                <CancelIcon onMouseDown={(event) => event.stopPropagation()} />
              }
              onDelete={(e) => handleRemoveBranch(e, value)}
            />
          ))}
        </Box>
      )}
    />
  );
};

export default BranchesReportSelect;
